import { Navbar } from "../components/site/Navbar";
import { Hero } from "../components/site/Hero";
import { Marquee } from "../components/site/Marquee";
import { About } from "../components/site/About";
import { Services } from "../components/site/Services";
import { SchoolSaaS } from "../components/site/SchoolSaaS";
import { WhyRCS } from "../components/site/WhyRCS";
import { Process } from "../components/site/Process";
import { TechStack } from "../components/site/TechStack";
import { Portfolio } from "../components/site/Portfolio";
import { ArchitectureFlow } from "../components/site/ArchitectureFlow";
import { Security } from "../components/site/Security";
import { FAQ } from "../components/site/FAQ";
import { CTABanner } from "../components/site/CTABanner";
import { Contact } from "../components/site/Contact";
import { Footer } from "../components/site/Footer";
import { FloatingActions } from "../components/site/FloatingActions";
import { ChatWidget } from "../components/site/ChatWidget";

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white" data-testid="home-page">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <About />
        <Services />
        <SchoolSaaS />
        <WhyRCS />
        <Process />
        <TechStack />
        <Portfolio />
        <ArchitectureFlow />
        <Security />
        <FAQ />
        <CTABanner />
        <Contact />
      </main>
      <Footer />
      <FloatingActions />
      <ChatWidget />
    </div>
  );
}
